import { render } from "./ProductAdvantages.vue?vue&type=template&id=bc04ec6e&scoped=true"
import script from "./ProductAdvantages.vue?vue&type=script&lang=js"
export * from "./ProductAdvantages.vue?vue&type=script&lang=js"

import "./ProductAdvantages.vue?vue&type=style&index=0&id=bc04ec6e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/sms-166dx-web-frontend-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc04ec6e"]])

export default __exports__